import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
export function Gen2EChestGearPage() {
  const options = ['Size 0 Red (Out of Stock Can order)', 'Size 0 Blue (Out of Stock Can order)', 'Size 1 Red (2 Reds In Stock)', 'Size 1 Blue (3 Blues In Stock)', 'Size 2 Red (1 Red In Stock) (+$20.00)', 'Size 2 Blue (2 Blue In Stock) (+$20.00)', 'Size 3 Red (OUT OF STOCK inquiry) (+$20.00)', 'Size 3 Blue (OUT OF STOCK inquiry) (+$20.00)', 'Size 4 Red (1 Red In Stock) (+$40.00)', 'Size 4 Blue (2 Blue In Stock) (+$40.00)', 'Size 5 Red (2 Red In Stock) (+$40.00)', 'Size 5 Blue (2 Blue In Stock) (+$40.00)'];
  return <div className="min-h-screen bg-white flex flex-col font-sans text-gray-900" data-id="element-605">
      <Header data-id="element-606" />

      <main className="flex-grow pt-32 pb-20" data-id="element-607">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-608">
          {/* Product Title */}
          <div className="text-center mb-12" data-id="element-609">
            <h1 className="text-3xl md:text-4xl font-bold text-red-600" data-id="element-610">
              Gen2 E-Chest Gear Adult Size
            </h1>
          </div>

          {/* Top Split Layout */}
          <div className="flex flex-col md:flex-row gap-12 mb-16 items-start" data-id="element-611">
            {/* Left: Image */}
            <div className="w-full md:w-1/2 flex flex-col items-center" data-id="element-612">
              <div className="bg-white rounded-xl p-4 mb-4 w-full max-w-md flex justify-center" data-id="element-613">
                <img src="https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg" alt="Gen2 E-Chest Gear Adult Size" className="w-full h-auto object-contain" data-id="element-614" />
              </div>
              {/* Thumbnails */}
              <div className="flex gap-4 justify-center" data-id="element-615">
                <div className="w-16 h-16 border border-gray-200 rounded p-1 cursor-pointer hover:border-red-500" data-id="element-616">
                  <img src="https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg" alt="Red Thumbnail" className="w-full h-full object-contain" data-id="element-617" />
                </div>
                <div className="w-16 h-16 border border-gray-200 rounded p-1 cursor-pointer hover:border-blue-500" data-id="element-618">
                  <img src="https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg" alt="Blue Thumbnail" className="w-full h-full object-contain grayscale" style={{
                  filter: 'hue-rotate(220deg)'
                }} data-id="element-619" />
                </div>
              </div>
            </div>

            {/* Right: Options & Add to Cart */}
            <div className="w-full md:w-1/2 flex flex-col" data-id="element-620">
              <h3 className="text-lg font-bold mb-4" data-id="element-621">Choose Size</h3>

              <div className="flex flex-col gap-2 mb-8" data-id="element-622">
                <div className="flex justify-end pr-2" data-id="element-623">
                  <span className="text-xs font-bold text-gray-700" data-id="element-624">Qty</span>
                </div>
                {options.map((option, idx) => <div key={idx} className="flex items-center justify-between gap-4 text-sm text-gray-700" data-id="element-625">
                    <span className="flex-grow" data-id="element-626">{option}</span>
                    <input type="number" min="0" defaultValue="0" className="w-16 px-2 py-1 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-627" />
                  </div>)}
              </div>

              <div className="text-center mb-6" data-id="element-628">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-629">Dimensions</h4>
                <p className="text-gray-700 mb-4" data-id="element-630">36 x 18 x 5</p>
                <p className="text-sm text-gray-500 mb-1" data-id="element-631">Your Price</p>
                <p className="text-2xl font-black text-gray-900 mb-4" data-id="element-632">
                  $775.00
                </p>
                <Button variant="primary" className="bg-red-700 hover:bg-red-800 focus:ring-red-700 text-lg px-8 py-3" data-id="element-633">
                  Add to Cart
                </Button>
              </div>
            </div>
          </div>

          {/* Bottom: Description & Suggested Products */}
          <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-634">
            <div className="space-y-4 text-gray-800 mb-12" data-id="element-635">
              <p data-id="element-636">The Gen2 E-Chest-Gear can be used in practice or at events.</p>
              <p data-id="element-637">
                This product requires a Gen2 E-chest gear transmitter to link up
                to Ring Manager System.
              </p>
              <p data-id="element-638">
                The Gen1 E-Chest gear Adapter Transmitters will allow you to use
                your gen1 e-chest gear with the Gen2 electronics.
              </p>
              <p className="text-xs text-gray-500 italic" data-id="element-639">
                Please store the e-hogu flat and when you ship the e-hogu, it
                should always be flat and never put on a non moving object
              </p>
              <p data-id="element-640">
                We recommend that you use Gen1 footgear with Gen1 system and
                Gen2 footgear with Gen2 system.
                <br data-id="element-641" />
                Gen1 socks are not as sensitive on a Gen2 e-chest guard
                <br data-id="element-642" />
                You can not use Gen3 Daedo Socks on a Gen2 E-hogu.
              </p>
            </div>

            <div className="text-left w-full mb-12" data-id="element-643">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-644">
                Other Suggested TrueScore Products
              </h4>
              <ul className="flex flex-col gap-1" data-id="element-645">
                <li data-id="element-646">
                  <a href="#daedo-pss-systems" className="text-blue-600 hover:underline" data-id="element-647">
                    Gen2 Head Transmitter
                  </a>
                </li>
                <li data-id="element-648">
                  <a href="#daedo-pss-systems" className="text-blue-600 hover:underline" data-id="element-649">
                    Gen2 Receiver
                  </a>
                </li>
                <li data-id="element-650">
                  <a href="#daedo-pss-systems" className="text-blue-600 hover:underline" data-id="element-651">
                    Gen2 E-HeadGear
                  </a>
                </li>
              </ul>
            </div>

            <Button variant="primary" className="bg-red-700 hover:bg-red-800 focus:ring-red-700 px-8" onClick={() => window.history.back()} data-id="element-652">
              Back
            </Button>
          </div>
        </div>
      </main>

      <Footer data-id="element-653" />
    </div>;
}